import { AbstractPmsApiService } from "./abstract.service";

export class ImageUploadPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string[]}
     */
    static get $inject() {
        
        return super.$inject.concat([ 'Upload' ]);
    }
    
    constructor(http, config, eventsBroker, $injector, Upload) {
        
        super(http, config, eventsBroker, $injector);
        
        this.Upload = Upload;
    }
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/image/upload/:method';
    }
    
    upload(images, folder) {
        const url  = this.url({method: 'multiple' });
        return this.Upload.upload({
            url:     url,
            headers: this.authHeaders,
            data:    {images: images, folder: folder}
        });
    }
    
    tinyMCEUpload(blobInfo) {

        const url  = this.url({method: 'tinymce'})

        let formData = new FormData();
        
        formData.append('image', blobInfo.blob(), blobInfo.filename());
        formData.append('folder', 'tinymce');
        
        return this.http
                   .post(url, formData, {
                       transformRequest: angular.identity,
                       headers: angular.extend(this.authHeaders, {
                           'Content-Type': undefined
                       })
                   });
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/image-upload.service.js